import React from 'react';
import './RankSkinFrame.css';
import {getRankSkinFramePath} from '../../utils/factions/getRankSkinFramePath';
import {getFactionRankSkinTitle, parseRankSkinId} from '../../utils/factions/getFactionRankSkinTitle';

/**
 * Рамка рейтингового образа поверх иконки фракции или самого образа: золотая
 * у образа Золотой Лиги, алмазная — у Алмазной, рубиновая — у Рубиновой. У
 * остальных образов рамки нет, и компонент не рисует ничего.
 *
 * Кладется тем же приемом, что значок бота и знак бана (см. VisibleBotMark,
 * FactionBanMark): абсолютным слоем поверх, опора — контейнер иконки. Размер
 * по умолчанию во всю опору, а точечно подгоняется переменной
 * --rank-skin-frame-size, чтобы рамка садилась на иконки разной верстки
 *
 * @param {Object} props
 * @param {string} [props.skinId] - образ игрока (`humans_gold`)
 * @param {string} [props.className] - для точечной подгонки размера
 */
const RankSkinFrame = ({skinId, className = ''}) => {
  const framePath = getRankSkinFramePath(skinId);
  if (!framePath) {
    return null;
  }

  const {factionId, rank} = parseRankSkinId(skinId);

  return (
    <img
      className={`rank-skin-frame ${className}`}
      src={framePath}
      alt={''}
      // Название образа уже стоит подсказкой на самой иконке — рамке своя не
      // нужна, но для чтения с экрана она остается декорацией
      aria-hidden={'true'}
      title={getFactionRankSkinTitle(factionId, rank)}
    />
  );
};

export default RankSkinFrame;
